import type { TModelNormalizerSetting } from 'app/API/custom/asr-model-settings/types';

export const getEnabledPipelineNames = (
  entries: Pick<TModelNormalizerSetting, 'name' | 'enabled'>[],
  draft: string[] | null,
): string[] => draft ?? entries.filter((entry) => entry.enabled).map((entry) => entry.name);
